import { type FunctionalComponent, h } from '@stencil/core';
import type { ITabExtended } from '../types/subcomponents-types.type';
import { ViewResultList } from '../view-result-list/view-result-list';
import { SearchPaginationTag } from '../../../tabs-pagination-v2/search-pagination-tag';

export const DefaultView: FunctionalComponent<ITabExtended> = ({ ...props }) => {
    // Remove mobileView after finishing mobile view for dashboard
    // and bring back !props.tabularView && !props.isDashboardView ? <div ....
    return (
      !props.tabularView && (!props.isDashboardView || (props.isDashboardView && props.mobileView)) ? <div class="default-view">
        <ViewResultList
          labelProvider={(e, f) => props.labelProvider(e, f)}
          aggregatedResults={props.aggregatedResults}
          queryResult={props.queryResult}
          strategies={props.strategies}
          resultRenderer={props.resultRenderer}
          resultClickAnalytics={props.resultClickAnalytics}
          country={props.country}
          language={props.language}
          gridView={props.gridView}
          isEcommerceMode={props.isEcommerceMode}
          eShop={props.eShop}
          sortOption={props.sortOption}
          sortingResults={props.sortingResults}
          reflectedState={props.reflectedState}
          scrollToTop={props.scrollToTop}
          rtl={props.rtl}
          productCatalogWidget={props.productCatalogWidget}
          query={props.query}
          isAdditionalConditionsWidgetActive={props.isAdditionalConditionsWidgetActive}
          isMiaPromotionWidget={props.isMiaPromotionWidget}
          miaData={props.miaData}
          marketingProductBadgesFilters={props.marketingProductBadgesFilters}
          wcEventData={props.wcEventData}
          isUnifiedCheckout={props.isUnifiedCheckout}
          isSubstitutionTool={props.isSubstitutionTool}
          resultIndexOffset={props.resultIndexOffset}
        />
        <SearchPaginationTag
          perPage={props.perPage}
          currentPage={props.currentPage}
          queryResult={props.queryResult}
          paginationChanged={props.paginationChanged.bind(props.context)}
          query={props.query}
          aggregatedResults={props.aggregatedResults}
          labelProvider={(e, f) => props.labelProvider(e, f)}
          reflectedState={props.reflectedState}
          disableFiltersOnLoading={props.disableFiltersOnLoading}
          hideQuery={props.hideQueryInPagination}
          strategies={props.strategies}
        />
        <slot name="after-pagination"/>
      </div> : ''
    );
};
